module.exports = __webpack_public_path__ + "neo24.png?c9ef727771e67d2f8b0d8982f0c779af";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/neo24.png
// module id = 984
// module chunks = 2